import axios from "./axiosInstance";
const { REACT_APP_ENVIRONMENT, REACT_APP_AUTH_SERVER_URL } = process.env;

function apiRequest(props) {
  const { url, init, query, option, config } = props;
  const basePath =
    REACT_APP_ENVIRONMENT === "sandbox" ? "/sandbox/internal" : "/internal";

  const urlWithBasePath = `${basePath}${url}`;
  // auth apis live on a separate host; undefined falls back to REACT_APP_SERVER_URL
  const baseURL = url.includes("/auth/") ? REACT_APP_AUTH_SERVER_URL : undefined;

  if (init.method === "POST") {
    return axios.post(urlWithBasePath, option, { ...config, baseURL });
  }
  if (init.method === "PATCH") {
    return axios.patch(urlWithBasePath, option, { baseURL });
  }
  if (init.method === "DELETE") {
    return axios.delete(urlWithBasePath, { data: option, baseURL });
  }
  return axios.get(urlWithBasePath, { params: option, baseURL });
}

const request = {
  get: (url, option) =>
    apiRequest({
      url,
      init: {
        method: "GET",
      },
      option,
    }),

  delete: (url, option) =>
    apiRequest({
      url,
      init: {
        method: "DELETE",
      },
      option,
    }),

  post: (url, option, config) =>
    apiRequest({
      url,
      init: {
        method: "POST",
      },
      option,
      config,
    }),
  patch: (url, option) =>
    apiRequest({
      url,
      init: {
        method: "PATCH",
      },
      option,
    }),
};

export default request;
